export const painPoints: string[] = [
  'Evenings disappearing into video searches for one combination you can actually use',
  'Sessions that start repeating themselves because planning time ran out',
  'That quiet worry that students — or their parents — can tell today was improvised',
  'No clear record of what each student has advanced week to week',
  'Recital season arriving with nothing structured to lean on',
  'Weekends handed over to planning instead of to your own life',
]

export const finalBenefits: string[] = [
  'Less searching: the combination that fits is already written down',
  'More structure: every class follows a technical objective, not a hunch',
  'More variety: fresh material for each week without starting over',
  'Clearer progression: what comes next is decided before you walk in',
  'Easier adapting: the same session works across ages and levels',
  'More confidence: nothing about your class feels last-minute',
  'More personal time: your evenings and weekends come back to you',
]

export interface ValueLine {
  label: string
  value: string
}

export const valueStack: ValueLine[] = [
  { label: 'Ballet Teacher Elite System — 6 Master Volumes', value: '$67' },
  { label: 'The 7 Strategic Bonuses', value: '$30' },
]

export const checkoutUrl =
  'https://ballet-teacher-elite-system.impultienda.ar/checkout'

export const heroImage =
  'https://cdn.magicpatterns.com/uploads/iFkpyXKUhb3nvV2bNVMfp1/ChatGPT_Image_6_sept_2026,_02_15_32-Photoroom.png'
